import React, { useEffect, useState } from 'react';
import './prizepack-display.styles.scss'
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { sortElementsNoThe } from '@/utils/sortElements';
import { getUniqueDocumentFromFirestore } from '@/utils/getDataFromDbSimplified';
import { getRarity } from '@/utils/prizeRarity';

// Pull a clean display name for a prizepack item. The element record is the
// source of truth; fall back to parsing the activity title ("Item Earned: X").
function getItemName(item, element) {
  if (element?.name) return element.name;
  if (item.title && item.title.indexOf(': ') > -1) return item.title.split(': ')[1];
  return item.title ?? 'Item';
}

const PrizepackDisplay = ({
  items, // object of prizepack items from data display
  gameElements, // object of game elements that can be referenced by prizepack items
  rewardData
}) => {

  const [selected, setSelected] = useState(null);
  const [ itemList, setItemList] = useState([]);
  const [ prizePackData, setPrizePackData ] = useState(null);
  const selectedElement = selected ? gameElements?.[selected.id] : null;
  const selectedRarity = selected
    ? getRarity(prizePackData?.opt_prizeWeights?.[selected.id]?.weight)
    : null;

  useEffect(() => {
    if (!items || !gameElements) return;
    const list = Object.values(items).map(item => {
      return gameElements[item.id] ?? null;
    }).filter(item => item !== null);
    setItemList(list);
  }, [items, gameElements])

  useEffect(() => {
    if (!rewardData) return;
    getPrizePackData();
  }, [rewardData])

  function getPrizePackData() {
    getUniqueDocumentFromFirestore({
      'path': `games/${rewardData.gameId}/gameElements/${rewardData.elementId}`,
      'once': true,
      'callback': callback
    })
    function callback(data) {
      if (!data) return;
      setPrizePackData(data);
    }
  }

  return (
    <div className='prizepack-display-container'>
      {
        (selected)
          ?
          <div className='prizepack-detail'>
            <button
              className='prizepack-detail-back g-button small-btn'
              onClick={() => setSelected(null)} >
              <FontAwesomeIcon icon={faArrowLeft} />
              Back
            </button>
            <div className='prizepack-detail-body'>
              <div className={`prizepack-detail-image ${selectedRarity ? 'rarity-' + selectedRarity.key : ''}`}>
                <ImageContainer
                  src={selected.icon}
                  alt={getItemName(selected, selectedElement)}
                  className='prizepack-item-icon'
                  containerHeight='180px'
                  containerWidth='180px'
                  preview={true} />
              </div>
              <div className='prizepack-detail-info'>
                <div className='prizepack-detail-name'>
                  {getItemName(selected, selectedElement)}
                </div>
                {
                  (selectedRarity) &&
                  <div className={`prizepack-rarity-badge rarity-${selectedRarity.key}`}>
                    {selectedRarity.label}
                  </div>
                }
                {
                  (selected.quantity > 1) &&
                  <div className='prizepack-detail-qty'>Quantity: {selected.quantity}</div>
                }
                {
                  (selectedElement?.desc) &&
                  <div className='prizepack-detail-desc'>{selectedElement.desc}</div>
                }
                <div className='prizepack-detail-meta'>
                  {
                    (selectedElement?.opt_cat) &&
                    <div>Category: {selectedElement.opt_cat}</div>
                  }
                  {
                    (selectedElement?.opt_market && selectedElement?.opt_marketPrice) &&
                    <div>Store Price: &#129689; {selectedElement.opt_marketPrice.toLocaleString()}</div>
                  }
                  {
                    (selectedElement?.opt_resale && selectedElement?.opt_resalePrice) &&
                    <div>Resale Value: &#129689; {selectedElement.opt_resalePrice.toLocaleString()}</div>
                  }
                </div>
              </div>
            </div>
          </div>
          :
          <div className='prizepack-detail'>
            <div className='prizepack-title g-list-item'>
              <ImageContainer
                src={rewardData?.icon}
                alt={rewardData?.title ?? 'Prize Pack'}
                className='prizepack-title-icon' />
              <h2>{rewardData?.title ?? 'Prize Pack'}</h2>
            </div>
            <div className='prizepack-grid'>
              {
                itemList.length > 0 &&
                sortElementsNoThe(itemList)
                  .map((item, index) => {
                    const element = gameElements?.[item.id];
                    const name = getItemName(item, element);
                    const rarity = getRarity(prizePackData?.opt_prizeWeights?.[item.id]?.weight);
                    return (
                      <div className='prizepack-card' key={item.id ?? index}>
                        <button
                          className={`prizepack-card-image ${rarity ? 'rarity-' + rarity.key : ''}`}
                          title={`View details for ${name}`}
                          onClick={() => setSelected(item)} >
                          <ImageContainer
                            src={item.icon}
                            alt={name}
                            className='prizepack-item-icon' />
                          {
                            (item.quantity > 1) &&
                            <span className='prizepack-quantity'>x{item.quantity}</span>
                          }
                        </button>
                        <div className='prizepack-card-name'>{name}</div>
                        {
                          (rarity) &&
                          <div className={`prizepack-card-rarity rarity-${rarity.key}`}>
                            {rarity.label}
                          </div>
                        }
                      </div>
                    )
                  })
              }
            </div>
          </div>
      }
    </div>
  )
}

export default PrizepackDisplay
